// src/ui/NavigationManager.js - Responsive Navigation Manager
// Handles mobile hamburger menu and desktop sidebar

export class NavigationManager {
    constructor() {
        this.isMobileMenuOpen = false;
        this.init();
    }

    init() {
        console.log('🧭 NavigationManager: Initializing responsive navigation');
        this.bindEvents();
        this.syncUserLabels();
    }

    bindEvents() {
        // Hamburger menu toggle
        const hamburgerBtn = document.getElementById('hamburger-btn');
        if (hamburgerBtn) {
            hamburgerBtn.addEventListener('click', () => {
                this.toggleMobileMenu();
            });
        }

        // Mobile menu close
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', () => {
                this.closeMobileMenu();
            });
        }

        // Mobile menu overlay close
        const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
        if (mobileMenuOverlay) {
            mobileMenuOverlay.addEventListener('click', (e) => {
                if (e.target === mobileMenuOverlay) {
                    this.closeMobileMenu();
                }
            });
        }

        // Sync mobile navigation buttons with desktop buttons
        this.syncNavigationButtons();
    }

    syncNavigationButtons() {
        // Map mobile buttons to desktop button functionality
        const buttonMappings = [
            { mobile: 'mobile-ribbon-mainmenu-btn', desktop: 'ribbon-mainmenu-btn' },
            { mobile: 'mobile-ribbon-analytics-btn', desktop: 'ribbon-analytics-btn' },
            { mobile: 'mobile-ribbon-tutorial-btn', desktop: 'ribbon-tutorial-btn' },
            { mobile: 'mobile-privacy-settings-btn', desktop: 'privacy-settings-btn' },
            { mobile: 'mobile-ribbon-logout-btn', desktop: 'ribbon-logout-btn' }
        ];

        buttonMappings.forEach(({ mobile, desktop }) => {
            const mobileBtn = document.getElementById(mobile);
            const desktopBtn = document.getElementById(desktop);
            
            if (mobileBtn && desktopBtn) {
                mobileBtn.addEventListener('click', () => {
                    // Close mobile menu first
                    this.closeMobileMenu();
                    
                    // Trigger desktop button functionality
                    setTimeout(() => {
                        desktopBtn.click();
                    }, 300); // Wait for menu close animation
                });
            }
        });
    }

    toggleMobileMenu() {
        const overlay = document.getElementById('mobile-menu-overlay');
        if (overlay) {
            if (this.isMobileMenuOpen) {
                this.closeMobileMenu();
            } else {
                this.openMobileMenu();
            }
        }
    }

    openMobileMenu() {
        const overlay = document.getElementById('mobile-menu-overlay');
        if (overlay) {
            overlay.classList.add('active');
            this.isMobileMenuOpen = true;
            console.log('🧭 Mobile menu opened');
            
            // Prevent body scroll
            document.body.style.overflow = 'hidden';
        }
    }

    closeMobileMenu() {
        const overlay = document.getElementById('mobile-menu-overlay');
        if (overlay) {
            overlay.classList.remove('active');
            this.isMobileMenuOpen = false;
            console.log('🧭 Mobile menu closed');
            
            // Restore body scroll
            document.body.style.overflow = '';
        }
    }

    syncUserLabels() {
        // Sync username across all displays
        const desktopLabel = document.getElementById('desktop-username-label');
        const mobileLabel = document.getElementById('mobile-username-label');
        const ribbonLabel = document.getElementById('ribbon-username-label');

        if (ribbonLabel && desktopLabel) {
            desktopLabel.textContent = ribbonLabel.textContent;
        }
        
        if (ribbonLabel && mobileLabel) {
            mobileLabel.textContent = ribbonLabel.textContent;
        }

        // Watch for changes to ribbon label and sync
        if (ribbonLabel) {
            const observer = new MutationObserver(() => {
                if (desktopLabel) desktopLabel.textContent = ribbonLabel.textContent;
                if (mobileLabel) mobileLabel.textContent = ribbonLabel.textContent;
            });
            
            observer.observe(ribbonLabel, { 
                childList: true, 
                subtree: true, 
                characterData: true 
            });
        }
    }

    // Method to update navigation state based on current scene
    updateNavigationState(currentScene) {
        // Add active states to navigation items based on current scene
        const navItems = document.querySelectorAll('.nav-item, .mobile-nav-item');
        navItems.forEach(item => {
            item.classList.remove('active');
        });

        // Set active state based on scene
        if (currentScene === 'AuthenticatedMenuSceneDOM' || currentScene === 'AuthenticatedMenuScene') {
            document.getElementById('ribbon-mainmenu-btn')?.classList.add('active');
            document.getElementById('mobile-ribbon-mainmenu-btn')?.classList.add('active');
        }
        // Add more scene-based active states as needed
    }
}

// Initialize navigation manager
let navigationManager;

document.addEventListener('DOMContentLoaded', () => {
    if (!navigationManager) {
        navigationManager = new NavigationManager();
        window.navigationManager = navigationManager;
        console.log('🧭 NavigationManager ready');
    }
});

// Make available globally
window.NavigationManager = NavigationManager;

export default NavigationManager;
